import {
  MarketingPlanSlotImageStatus,
  MarketingPlanSlotStatus,
  MarketingPlanSlotTextStatus,
  SocialMediaType,
} from '@/generated/graphql'

const PLATFORM_ICON = {
  [SocialMediaType.Facebook]: 'mdi-facebook',
  [SocialMediaType.Instagram]: 'mdi-instagram',
  [SocialMediaType.Linkedin]: 'mdi-linkedin',
  [SocialMediaType.GoogleBusiness]: 'mdi-google',
}

export function platformIcon(slot) {
  return PLATFORM_ICON[slot.platform] || 'mdi-share-variant'
}

export function eventVariant(slot) {
  if (slot.textStatus === MarketingPlanSlotTextStatus.Draft) return 'draft'
  if (slot.status === MarketingPlanSlotStatus.Approved) return 'approved'
  if (slot.textStatus === MarketingPlanSlotTextStatus.Failed) return 'failed'
  if (slot.textStatus === MarketingPlanSlotTextStatus.Generating) return 'generating'
  return 'ready'
}

export function isCardLoading(slot) {
  return slot.textStatus === MarketingPlanSlotTextStatus.Generating
}

// Review cards are drafts: a still placeholder. The image pulse runs only while
// the slot is GENERATING. Text and image are saved together, so a ready slot
// with no image is a finished attempt, not a load still in progress.
export function isImageLoading(slot) {
  return (
    slot.imageStatus === MarketingPlanSlotImageStatus.Pending ||
    (slot.textStatus === MarketingPlanSlotTextStatus.Generating && !slot.imageUrl)
  )
}

// Prefer the slot's own title in every state. A slot the user added by hand has
// no generated title until the plan is accepted, so fall back to its topic
// instead of an empty (skeleton) label.
export function cardTitle(slot) {
  return (slot.title || '').trim() || slot.topicName || ''
}

export function cardBody(slot, t) {
  if (slot.textStatus === MarketingPlanSlotTextStatus.Failed && !slot.generatedText) {
    return t('marketing-agent.dialog.failed')
  }
  if (
    slot.textStatus !== MarketingPlanSlotTextStatus.Ready &&
    slot.textStatus !== MarketingPlanSlotTextStatus.Failed
  )
    return ''
  return (slot.generatedText || '').trim()
}

export function monthEventLabel(slot, t) {
  return cardTitle(slot) || cardBody(slot, t)
}

export function groupSlotsByDate(slots) {
  const map = {}
  for (const slot of slots || []) {
    const date = slot?.scheduledLocal?.date
    if (!date) continue
    ;(map[date] ||= []).push(slot)
  }
  for (const date of Object.keys(map)) {
    map[date].sort((a, b) =>
      (a.scheduledLocal.time || '').localeCompare(b.scheduledLocal.time || '')
    )
  }
  return map
}
